"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Constant = require("../Constant");

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _theme;

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: inline-block;\n  border: 4px solid ", ";\n  border-top: 4px solid ", ";\n  border-radius: 50%;\n  width: 3.2rem;\n  height: 3.2rem;\n  animation: ", " 2s linear infinite;\n\n  /* these media queries are for Windows high contrast mode. This code allows the spinner to be visible for high contrast users */\n  @media (forced-colors: active) and (prefers-color-scheme: dark) {\n    border-top: 4px solid Highlight;\n  }\n  @media (forced-colors: active) and (prefers-color-scheme: light) {\n    border-top: 4px solid HighlightText;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var spinKeyframes = (0, _styledComponents.keyframes)(_templateObject());
var color = (0, _styledTheming.default)('mode', (_theme = {}, (0, _defineProperty2.default)(_theme, _Constant.Themes.CALIBER, _Constant.Color.TEAL), (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEBRIDGE, _Constant.Color.HOMEBRIDGE_BLUE), (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEPOINT, _Constant.Color.HOMEPOINT_LIGHT_BLUE), (0, _defineProperty2.default)(_theme, _Constant.Themes.SYNERGY_ONE, _Constant.Color.SYNERGY_ONE_YELLOW_DARK), (0, _defineProperty2.default)(_theme, _Constant.Themes.FIGURE, _Constant.Color.TEAL), (0, _defineProperty2.default)(_theme, _Constant.Themes.PETERSENDEAN, _Constant.Color.TEAL), (0, _defineProperty2.default)(_theme, _Constant.Themes.PELLA, _Constant.Color.TEAL), (0, _defineProperty2.default)(_theme, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.GUARANTEED_RATE_ARROW_RED), _theme));

var GuiSpinner = _styledComponents.default.span(_templateObject2(), color, _Constant.Color.SPIN_GREY, spinKeyframes);

var Spinner = function Spinner(props) {
  return /*#__PURE__*/_react.default.createElement(GuiSpinner, props);
};

var _default = Spinner;
exports.default = _default;